import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Flex from '@client/components/flex/Flex';
import playStore from '@client/shared/images/landingPageAssets/playstore.svg';
import appStore from '@client/shared/images/landingPageAssets/appstore.svg';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import svBgImgStart from '@client/shared/images/landingPageAssets/sv/bg-img-start.png';
import svBgImgStartMobile from '@client/shared/images/landingPageAssets/sv/bg-img-start-mobile.png';
import dkBgImgStart from '@client/shared/images/landingPageAssets/dk/bg-img-start.png';
import dkBgImgStartMobile from '@client/shared/images/landingPageAssets/dk/bg-img-start-mobile.png';
import noBgImgStart from '@client/shared/images/landingPageAssets/no/bg-img-start.png';
import noBgImgStartMobile from '@client/shared/images/landingPageAssets/no/bg-img-start-mobile.png';
import svAllerLogo from '@client/shared/images/landingPageAssets/sv/aller-national-logo-black.svg';
import dkAllerLogo from '@client/shared/images/landingPageAssets/dk/aller-national-logo-black.svg';
import noAllerLogo from '@client/shared/images/landingPageAssets/no/aller-national-logo-black.svg';
import styles from './startHeader.scss';

function StartHeader() {
  const { t, i18n } = useTranslation(['landing', 'common']);

  const activeLanguage = i18n.language ?? 'sv';

  let images;
  let allerLogo;

  switch (activeLanguage) {
    case 'sv':
      images = {
        desktop: svBgImgStart,
        mobile: svBgImgStartMobile,
      };
      allerLogo = svAllerLogo;
      break;
    case 'no':
      images = {
        desktop: noBgImgStart,
        mobile: noBgImgStartMobile,
      };
      allerLogo = noAllerLogo;
      break;
    case 'dk':
      images = {
        desktop: dkBgImgStart,
        mobile: dkBgImgStartMobile,
      };
      allerLogo = dkAllerLogo;
      break;
    default:
      images = {
        desktop: svBgImgStart,
        mobile: svBgImgStartMobile,
      };
      allerLogo = svAllerLogo;
      break;
  }

  return (
    <section className={styles.startHeader}>
      <picture className={styles.topImage}>
        <source media="(max-width: 767px)" srcSet={images.mobile} />
        <img className={styles.image} src={images.desktop} alt={''} />
      </picture>
      <div
        className={classNames(
          styleHelper.landingPageSectionContent,
          styles.contentContainer
        )}
      >
        <Flex
          column
          className={classNames(
            styles.partOfOurNetwork,
            styles.onTopOfBackgroundImage
          )}
        >
          <Flex className={styles.allerLogo}>
            <img src={allerLogo} alt={'Aller Media'} />
          </Flex>
          <h1
            className={classNames(styleHelper.landingH2, styles.networkHeader)}
          >
            {t('landing:startHeader.title')}
          </h1>
          <div>
            <p
              className={classNames(
                styleHelper.landingP1,
                styles.networkParagraph
              )}
            >
              {t('landing:startHeader.networkParagraph')}
            </p>
            <Flex className={styles.storeIconsContainer}>
              <a
                className={styles.icon}
                href={t('common:appStoreLink')}
                rel="noopener noreferrer"
                target="_blank"
              >
                <img src={appStore} alt={'Apple store'} />
              </a>
              <a
                className={styles.icon}
                href={t('common:playStoreLink')}
                rel="noopener noreferrer"
                target="_blank"
              >
                <img src={playStore} alt={'Google Play store'} />
              </a>
            </Flex>
          </div>
        </Flex>
        <Flex
          column
          className={classNames(styles.subTitle, styles.onTopOfBackgroundImage)}
        >
          <h2 className={styleHelper.landingH3}>
            {t('landing:startHeader.subTitle')}
          </h2>
          <p className={classNames(styleHelper.landingP1, styleHelper.mgt24)}>
            {t('landing:startHeader.paragraph1')}
          </p>
          <p className={classNames(styleHelper.landingP2, styleHelper.mgt16)}>
            {t('landing:startHeader.paragraph2')}
          </p>
        </Flex>
      </div>
    </section>
  );
}

export default StartHeader;
